import WidgetsConfig from "./conf/GEN_widgets_conf"
import WidgetsReglesEngagement from "./conf/GEN_Organigramme_RE"

// ==UserScript==
// @name         Script Widget Genesys
// @namespace    http://tampermonkey.net/
// @version      0.1
// @description  try to take over the world!
// @author       You
// @match
// @require		http://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js
// @require		https://cdnjs.cloudflare.com/ajax/libs/jquery-cookie/1.4.1/jquery.cookie.js
// @grant        none
// ==/UserScript==

// ChildNode.remove polyfill
(function (arr) {
	arr.forEach(function (item) {
	  if (item.hasOwnProperty('remove')) {
		return;
	  }
	  Object.defineProperty(item, 'remove', {
		configurable: true,
		enumerable: true,
		writable: true,
		value: function remove() {
		  if (this.parentNode !== null)
			this.parentNode.removeChild(this);
		}
	  });
	});
  })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

// This function will load a script and add it to the document.
var getScript = function(url, success) {
	// Create the new element.
	var script = document.createElement("script");
	script.src = url;

	// We'll be appending to <head>
	var head = document.getElementsByTagName("head")[0];
	var done = false;

	// Attach events for when the script is loaded.
	script.onload = script.onreadystatechange = function() {
		if (
			!done &&
			(!this.readyState ||
				this.readyState == "loaded" ||
				this.readyState == "complete")
		) {
			done = true;
			// Call the callback function.
			success();
			// Clean up.
			script.onload = script.onreadystatechange = null;
			head.removeChild(script);
		}
	};
	// Append the new script element.
	head.appendChild(script);
};
console.log("getScript defined");

var loadScript = function(scriptName) {
	var head = document.getElementsByTagName("head")[0];
	var script = document.createElement("script");
	script.type = "text/javascript";
	script.src = scriptName;
	script.async = false;
	head.appendChild(script);
};

var loadScript2 = function(scriptName, success) {
	var head = document.getElementsByTagName("head")[0];
	var script = document.createElement("script");
	script.type = "text/javascript";
	script.src = scriptName;
	script.async = false;
	head.appendChild(script);
	success();
};

/*	var genDevUrl = "http://VM-LOGSMSDEV1";
	var genProdUrl = "http://prod-genesys.legallais.tech";

	var genHost = "http://VM-LOGSMSDEV1:8080";
	var cobrowseUrl = "http://VM-LOGSMSDEV1:8000/cobrowse";
	var chatUrl =  "http://VM-LOGSMSDEV1:8080/genesys/2/chat/customer-support";
	var callbackUrl = genHost + "/genesys/1/service/callback/CallBack-Preview";
*/

	var gmsHost = WidgetsConfig.gmsHost;
	var gmsPort = WidgetsConfig.gmsPort;
	var widgetHost = WidgetsConfig.widgetHost;
	var cobrowseHost = WidgetsConfig.cobrowseHost;
	var cobrowsePort = WidgetsConfig.cobrowsePort;
	
	var countdown = WidgetsConfig.countdown ;
	var ActivationStat = WidgetsReglesEngagement.statsPourActivation;
	var NumeroScenario = WidgetsReglesEngagement.scenario;
	var Debugger = WidgetsConfig.debug;
	var gmsStats = gmsHost + "/genesys/1/internal_statistics";
	var widgetUrl = widgetHost + "/widgets/cxbus.min.js";
	var widgetPluginUrl = widgetHost + "/widgets/plugins/";
	var PageWebUrl = window.location.href;

	//var genUrl = __GENESYS__ ? genDevUrl : genProdUrl
	//var genUrl = genDevUrl ;
	//const NEEDED_AGENTS_NUMBER = process.env.NODE_ENV === "production" ? 2 : 1;
	const NEEDED_AGENTS_NUMBER = WidgetsReglesEngagement.NbMinAgentsChats;

	//chat
	var apparitionChatBox = WidgetsConfig.apparitionChatBox;
	var CalendrierServiceChat = WidgetsConfig.CalendrierServiceChat;
	var ChatServiceName = WidgetsConfig.ChatServiceName;
	var GroupAgentsChatStats = WidgetsReglesEngagement.GroupAgentsChatStats;
	var FileChatStats = WidgetsReglesEngagement.FileChatStats;
	var isActiveChat = WidgetsReglesEngagement.activation_chat;
	var NbMinAgentsChats = WidgetsReglesEngagement.NbMinAgentsChats;
	var NbMaxChatAttente = WidgetsReglesEngagement.NbMaxChatAttente;

	//callback
	var CallbackServiceName = WidgetsConfig.CallbackServiceName;
	var CalendrierServiceCallback = WidgetsConfig.CalendrierServiceCallback;
	var isActiveCTM = WidgetsReglesEngagement.activation_wcb;
	var isActiveWCB = WidgetsReglesEngagement.activation_ctm;
	var GroupAgentsCallbackStats = WidgetsReglesEngagement.GroupAgentsCallbackStats;
	var FileCallbackStats = WidgetsReglesEngagement.FileCallbackStats;
	var NbMinAgentsCallback	 = WidgetsReglesEngagement.NbMinAgentsCallback	;
	var NbMaxCallbackAttente = WidgetsReglesEngagement.NbMaxCallbackAttente;
	
	/***************************************************/
	// Statistiques sur les Chat et Callback
	//chat
	var statLog_AG_Chat;
	var statRdy_AG_Chat;
	var statRout_AG_Chat;
	var statAtt_Chat_VQ;
	var ParamsStatChatLogin;
	var ParamsStatChatReady;
	var ParamsStatChatWaiting;
	var ParamsStatChatRoutable;
	//callback	
	var statLog_AG_Callback;
	var statRdy_AG_Callback;
	var statRout_AG_Callback;
	var statAtt_Callback_VQ;
	var ParamsStatCallbackLogin;
	var ParamsStatCallbackReady;
	var ParamsStatCallbackWaiting;
	var ParamsStatCallbackRoutable;
	
	// Statistiques sur les Calendriers
	var ErreurCalendrier;
	var PeriodesCalendrier;
	var CalendrierOuvertPourChat;
	var CalendrierOuvertReponseChat=false;
	var CalendrierOuvertPourCallback;
	var CalendrierOuvertReponseCallback=false;

	/***************************************************/
	// URL constituées Architecture
	//chat
	var chatUrl =  gmsHost + "/genesys/2/chat/"+ChatServiceName;
	var officeHoursUrlChat = gmsHost + "/genesys/1/service/"+CalendrierServiceChat;

	//callback
	var callbackUrl = gmsHost + "/genesys/1/service/callback/"+CallbackServiceName;
	var officeHoursUrlCallback = gmsHost + "/genesys/1/service/"+CalendrierServiceCallback;
	
	//cobrowse	
	var cobrowseUrl = cobrowseHost +':'+ cobrowsePort + "/cobrowse";
	
	ParamsStatChatLogin = '"statLog_AG_Chat":{"objectId":"'+GroupAgentsChatStats+'","objectType":"GroupAgents","tenant":"Environment","tenantPassword":"","metric":"CurrAgentsLoggedIn","filter":"","notificationMode":"Immediate","timeProfile":"","timeRange":"","timeRange2":""}'
	ParamsStatChatReady = '"statRdy_AG_Chat":{"objectId":"'+GroupAgentsChatStats+'","objectType":"GroupAgents","tenant":"Environment","tenantPassword":"","metric":"CurrentReadyAgents","filter":"","notificationMode":"Immediate","timeProfile":"","timeRange":"","timeRange2":""}'
	ParamsStatChatWaiting = '"statAtt_Chat_VQ":{"objectId":"'+FileChatStats+'","objectType":"Queue","tenant":"Environment","tenantPassword":"","metric":"CurrNumberWaitingCalls","filter":"","notificationMode":"Immediate","timeProfile":"","timeRange":"","timeRange2":""}'
	//ParamsStatChatRoutable = '"statRout_AG_Chat":{"objectId":"'+GroupAgentsChatStats+'","objectType":"GroupAgents","tenant":"Environment","tenantPassword":"","metric":"Number_of_chats_routable_to_group","filter":"","notificationMode":"Immediate","timeProfile":"","timeRange":"","timeRange2":""}'
	ParamsStatCallbackLogin = '"statLog_AG_Callback":{"objectId":"'+GroupAgentsCallbackStats+'","objectType":"GroupAgents","tenant":"Environment","tenantPassword":"","metric":"CurrAgentsLoggedIn","filter":"","notificationMode":"Immediate","timeProfile":"","timeRange":"","timeRange2":""}'
	ParamsStatCallbackReady = '"statRdy_AG_Callback":{"objectId":"'+GroupAgentsCallbackStats+'","objectType":"GroupAgents","tenant":"Environment","tenantPassword":"","metric":"CurrentReadyAgents","filter":"","notificationMode":"Immediate","timeProfile":"","timeRange":"","timeRange2":""}'
	ParamsStatCallbackWaiting = '"statAtt_Callback_VQ":{"objectId":"'+FileCallbackStats+'","objectType":"Queue","tenant":"Environment","tenantPassword":"","metric":"CurrNumberWaitingCalls","filter":"","notificationMode":"Immediate","timeProfile":"","timeRange":"","timeRange2":""}'
	//ParamsStatCallbackRoutable = '"statRout_AG_Callback":{"objectId":"'+GroupAgentsCallbackStats+'","objectType":"GroupAgents","tenant":"Environment","tenantPassword":"","metric":"Number_of_callbacks_routable_to_group","filter":"","notificationMode":"Immediate","timeProfile":"","timeRange":"","timeRange2":""}'
	
//ORI	var paramsStats = '{'+ParamsStatChatLogin + ',' + ParamsStatChatReady + ',' + ParamsStatChatWaiting + ',' + ParamsStatChatRoutable + ','+ ParamsStatCallbackLogin + ',' + ParamsStatCallbackReady + ',' + ParamsStatCallbackWaiting + ',' + ParamsStatCallbackRoutable +'}';
	var paramsStats = '{'+ParamsStatChatLogin + ',' + ParamsStatChatReady + ',' + ParamsStatChatWaiting + ',' + ParamsStatCallbackLogin + ',' + ParamsStatCallbackReady + ',' + ParamsStatCallbackWaiting +'}';

(function() {
	"use strict";

	if (!window._genesys) window._genesys = {};
	if (!window._gt) window._gt = [];

	window._genesys.widgets = {
		main: {
			theme: "dark",
            lang: "fr",
            i18n: "widgets/i18n/widgets-fr.i18n.json",
			mobileMode: "auto",
			mobileModeBreakpoint: 600
		},

		webchat: {
			dataURL: chatUrl,
			userData: {},
			proactive: {
				enabled: false,
				idleTimer: 5,
				cancelTimer: 30
			},
		},

		callback: {
			apikey: "n3eNkgXXXXXXXXOXXXXXXXXA",
			apiVersion: "v1",
			serviceName: "service",
			dataURL: callbackUrl,
			countryCodes: false,
			immediateCallback :true,
            scheduledCallback :false,
			callDirection: "USERTERMINATED",
			userData: {
			  customerNumber: "",
			  PFS_id: "",
			  _callback_phone_number: "",
			  _customername: "" + " " + "",
			  _callback: "true",
			  _xtemplate: "Legallais",
			  _app_name: "Genesys",
			  waitForAgent: "true",
			  waitForUserConfirm: "false",
			  _target: "?:DVA_CALLBACK_ORGANIGRAMME >=1",
			  _call_direction: "USERTERMINATED",
			  _wait_for_agent: true,
			  _wait_for_user_confirm: false,
			  _media_type: "voice",
			},
		  },

		cobrowse: {
			src: cobrowseUrl + "/js/gcb.min.js",
			url: cobrowseUrl
		},

		sidebar: {
			showOnStartup: false,
			position: "left",
			expandOnHover: true,
			channels: [
				{
					name: "WebChat"
				},
				{
					name: "Callback"
				},
				{
                    //enable: __GENESYS__ ? true : false,
					enable: true, 
					name: "CoBrowse",
					clickCommand: "CoBrowse.open",
					displayName: "Co Navigation",
					i18n: "CobrowseTitle",
					icon: "cobrowse",
					html: ""
				}
			]
		}
	};
	window._genesys.widgets.main.preload = [
		"sidebar",
		"callback",
		"webchat",
		"Cobrowse"
	];

	window._genesys.widgets.webchat.form = {
		wrapper: "<table></table>",
		inputs: [
			{
				id: "cx_webchat_form_firstname",
				name: "firstname",
				maxlength: "100",
				placeholder: "@i18n:webchat.ChatFormPlaceholderFirstName",
				label: "@i18n:webchat.ChatFormFirstName",
				title: "Prénom",
				type: "text",
				validate: function(event, form, input, label, $, CXBus, Common){
					// Bypass the first validation call because validate function is called on form initialization but input is not in the DOM yet
					if(!input) { return true; }
					if(!$.trim(input.val())) { return false; }
					return true;
				}
			},
			{
				id: "cx_webchat_form_lastname",
				name: "lastname",
				maxlength: "100",
				placeholder: "@i18n:webchat.ChatFormPlaceholderLastName",
				label: "@i18n:webchat.ChatFormLastName",
				title: "Nom",
				type: "text",
				validate: function(event, form, input, label, $, CXBus, Common){
					// Bypass the first validation call because validate function is called on form initialization but input is not in the DOM yet
					if(!input) { return true; }
					if(!$.trim(input.val())) { return false; }
					return true;
				}
			},
			{
				id: "cx_webchat_form_NumMobile",
				name: "NumMobile",
				maxlength: "100",
				placeholder: "@i18n:webchat.ChatFormPlaceholderNumMobile",
				label: "@i18n:webchat.ChatFormNumMobile",
				title: "Numéro Tél",
				type: "text",
				validate: function(event, form, input, label, $, CXBus, Common){
					// Bypass the first validation call because validate function is called on form initialization but input is not in the DOM yet
					if(!input) { return true; }

					var value = $.trim(input.val());

					if(!value) { return false; }
					if(value.length < 10) {return false;} 
					if(!value.match(/^(\+)?\d*$/)) { return false; }
					return true;
				}
			},
			{
				id: "cx_webchat_form_email",
				name: "email",
				maxlength: "100",
				placeholder: "@i18n:webchat.ChatFormPlaceholderEmail",
				label: "@i18n:webchat.ChatFormEmail",
				title: "Enter your email address",
				type: "text"
			},
			{
				id: "cx_webchat_form_subject",
				name: "subject",
				maxlength: "100",
				placeholder: "@i18n:webchat.ChatFormPlaceholderSubject",
				label: "@i18n:webchat.ChatFormSubject"
			},
		]
	};

	window._genesys.widgets.callback.form = {
		wrapper: "<table></table>",
		inputs: [
			{
				id: "cx_form_callback_firstname",
				name: "firstname",
				maxlength: "100",
				placeholder: "@i18n:callback.CallbackPlaceholderRequired",
				label: "@i18n:callback.CallbackFirstName",
				validate: function(event, form, input, label, $, CXBus, Common){
					// Bypass the first validation call because validate function is called on form initialization but input is not in the DOM yet
					if(!input) { return true; }
					if(!$.trim(input.val())) { return false; }
					return true;
				}
			},
			{
				id: "cx_form_callback_lastname",
				name: "lastname",
				maxlength: "100",
				placeholder: "@i18n:callback.CallbackPlaceholderRequired",
				label: "@i18n:callback.CallbackLastName",
				validate: function(event, form, input, label, $, CXBus, Common){
					// Bypass the first validation call because validate function is called on form initialization but input is not in the DOM yet
					if(!input) { return true; }
					if(!$.trim(input.val())) { return false; }
					return true;
				}
			},
			{
				id: "cx_form_callback_phone_number",
				name: "phonenumber",
				maxlength: "14",
				placeholder: "@i18n:callback.CallbackPlaceholderRequired",
				label: "@i18n:callback.CallbackPhoneNumber",
				onkeypress: function(event) {
					// To allow only number inputs
					return (event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 43)
				},
				validate: function(event, form, input, label, $, CXBus, Common){
					// Bypass the first validation call because validate function is called on form initialization but input is not in the DOM yet
					if(!input) { return true; }

					var value = $.trim(input.val());

					if(!value) { return false; }
					if(value.length < 10) {return false;} 
					if(!value.match(/^(\+)?\d*$/)) { return false; }
					return true;
				}
			},
			{
				id: "cx_form_callback_subject",
				name: "Objet",
				type: "textarea",
				maxlength: "100",
				placeholder: "@i18n:callback.CallbackPlaceholderOptional",
				label: "Objet"
			}
		]
	}

	var s = document.createElement("script");
	s.async = 1;
	s.src = "https://apps.mypurecloud.com/widgets/9.0/cxbus.min.js";

	s.addEventListener("load", function() {
		console.log("+++++ script loaded");
		CXBus.configure({
			debug: true,
			pluginsPath: "https://apps.mypurecloud.com/widgets/9.0/plugins/"
		});

		CXBus.loadPlugin("widgets-core", "sidebar", "webchat", "callback");

		CXBus.subscribe('SideBar.opened', function(e){
			var sidebarWidget = document.querySelector('.cx-sidebar');
			var genesysBranding = document.querySelector('.cx-branding');

			// Center widget vertically
			if(sidebarWidget) {
				sidebarWidget.style.top = "50%";
				sidebarWidget.style.transform = "translateY(-50%)";
			}

			// Remove Genesys branding
			if(genesysBranding) {
				genesysBranding.parentNode.remove();
			}
		});

		CXBus.subscribe("WebChat.opened", function(e) {
			var chatWidget = document.querySelector(".cx-webchat");

			if(chatWidget) {
				chatWidget.style.marginRight = "145px";
			}
		});
	});

	document.head.appendChild(s);
	console.log("Genesys Widget inserted");
})();

function checkForReadyAgentChat() {
	var xhr = new XMLHttpRequest();

	var url = gmsStats;

	//var params = '{"statLog_AG_chat":{"objectId":"DVA_CHAT_ORGANIGRAMME_900_CONSEILLER_900","objectType":"GroupAgents","tenant":"Environment","tenantPassword":"","metric":"CurrAgentsLoggedIn","filter":"","notificationMode":"Immediate","timeProfile":"","timeRange":"","timeRange2":""},"statRdy_AG_chat":{"objectId":"DVA_CHAT_ORGANIGRAMME_900_CONSEILLER_900","objectType":"GroupAgents","tenant":"Environment","tenantPassword":"","metric":"CurrentReadyAgents","filter":"","notificationMode":"Immediate","timeProfile":"","timeRange":"","timeRange2":""}}';
	//var paramsStats = '{'+ParamsStatChatLogin + ',' + ParamsStatChatReady + ',' + ParamsStatChatWaiting + ',' + ParamsStatChatRoutable + ','+ ParamsStatCallbackLogin + ',' + ParamsStatCallbackReady + ',' + ParamsStatCallbackWaiting + ',' + ParamsStatCallbackRoutable +'}';

	xhr.open("POST", url, true);

	xhr.setRequestHeader("Content-Type", "application/json");
	xhr.onload = function() {
		if (xhr.status === 200) {
			var result = JSON.parse(xhr.responseText);

			var loggedAgents = result.statLog_AG_chat;
			var readyAgents = result.statRdy_AG_chat;

            if (readyAgents < Number.parseInt(NEEDED_AGENTS_NUMBER)) { 
				console.log('Not enough agent ready');
				return;
			};

			CXBus.command('SideBar.open');
		}
	};

	xhr.send(paramsStats);
}


window.setTimeout(function() {
	checkForReadyAgentChat();
}, 3000);



// WEBPACK FOOTER //
// ./genesys/widgets/widgets.config.js